<template>
<div style="margin: 0; padding: 0" id="wrapper">
<div id="logo_chat_nuevo">
          <img style="margin: 20px" src="https://imagenes.leon.gob.mx/logo-leon-bco.svg" width="150px" >
      </div>
  <div class="text-center"><br><br>
   <h2 class="h3 mb-3 font-weight-normal tituloblanco">Un operador te atenderá en breve, <br> espera un momento 
   <br><br>
   <p class="avisoNaranja">No refresques tu navegador</p>. . .</h2>
    <div class="a" style="--n: 5;">
      <div class="dot" style="--i: 0;"></div>
      <div class="dot" style="--i: 1;"></div>
      <div class="dot" style="--i: 2;"></div>
      <div class="dot" style="--i: 3;"></div>
      <div class="dot" style="--i: 4;"></div>
    </div>
  </div>
</div>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'Sala',
  props: {
    msg: String
  },
  data() {
    return {
      key: null,
      secondsToWait:125,
      waitTime :null,
      backgroundcolor: "#EEEEED",
    }
  },
  methods: {
    closeSession() {
      firebase.database().ref(`lobby/users/${this.key}`).remove();
      this.$router.push({
        name: "Login"
      })
      localStorage.removeItem('sesionID');
    },
    onEnterLobbie() {
      /* verificar si existen operadores al entrar al lobbie*/
      var self = this;
       firebase.database().ref('/users/online').once('value').then(snap => {
        if (snap.exists()){
          let operators =Object.keys( snap.val());
            if(operators.length==0){
               /* no hay operadores */
              self.closeSession();
            }
          } 
          else{
            /* no hay operadores */
            self.closeSession();
          }
        })
      if (localStorage.sesionID) {
         self.key = localStorage.sesionID;
         self.listenOperator(self.key, self);
      } else {
        var ref = firebase.database().ref('lobby/users').push({
          username: this.name,
          email: this.email,
          name: "",
          ip: this.ipAddress,
          status: "0",
          origen:"web",
          date: Date.now()
        }).then((snap) => {
          self.key = snap.key;
          localStorage.sesionID = snap.key;
          this.listenOperator(self.key, self);
        })
      }
    },
    listenOperator(key, self) {
      /* Escuchando cambio en operador */
      var self = this
      var ref = firebase.database().ref(`lobby/users/${key}`);
      ref.on('value', function (snapshot) {
        /* Verificar si el status cambio */
        if (snapshot.val() != null && parseInt(snapshot.val().status)) {
          //console.log(`el operadot tomo el chat ${key}, proceder a quitar del loby`);
          /* ir a la vista de chat*/
          if(parseInt(snapshot.val().status)==1){
            clearInterval(self.waitTime)
            self.$router.push({
              name: "Atencion",
              params: {
                "keyId": key,
                "ipAddress": self.ipAddress
                
              }
            })
          }
        }
      });
    },
    
    onOperatorClosesBrowser() {
      /* usuario cierra browser en la sala de espera*/
      if (localStorage.sesionID) {
        firebase
        .database()
        .ref(`lobby/users/${localStorage.sesionID}`)
        .remove();
         clearInterval(self.waitTime)
        this.$router.push({
          name: "Login"
        })
      }
    },
    /* crea timer para limitar el tiempo de espera*/
    iniciarTimer(){
      console.log("inicia timer")
      let self = this;
      let currentSecond = 0;
      self.waitTime = setInterval(()=>{
         if(parseInt(currentSecond)>=parseInt(self.secondsToWait)){
           console.log(":) smile")
           clearInterval(self.waitTime)
           self.onOperatorClosesBrowser()
            localStorage.removeItem('sesionID');
         }
         else{
            currentSecond++
         }
      },1000);
    },
  },

  created() {
    let self = this;
    self.iniciarTimer();
    /* Buscar sesion */
    window.addEventListener("beforeunload",this.onOperatorClosesBrowser);
    if (localStorage.sesionID==null) {
      if(this.$route.params.name!=null){
       this.name = this.$route.params.name;
       this.email = this.$route.params.email;
       this.ipAddress = this.$route.params.ipAddress;
      this.onEnterLobbie();
      }
      else{
        localStorage.removeItem('sesionID');
        this.$router.push({name: "Login"})
      }
    }
    else{
       let activeSession = localStorage.sesionID;
       firebase.database().ref(`/lobby/users/${activeSession}`).once('value').then(function(snap){ 
              /* hay sesion activa */
              if(snap.val()!=null){
                /* verificar el status de la conversaion */
                if(snap.val().status==0){
                  /* esta en sala de espera*/
                  console.log("en espera")
                  self.onEnterLobbie();
                }
                else if(snap.val().status==4 || snap.val().status==3 || snap.val().status==1){
                  /* el operador/usuario estan desconectados. lo manda a charla */
                  clearInterval(self.waitTime)
                  self.$router.push({
                    name: "Atencion",
                    params: {
                      "keyId": activeSession,
                      "as":snap, // OJO
                      "ipAddress": this.ipAddress
                    }
                  })
                }
                else{
                   localStorage.removeItem('sesionID');
                  self.$router.push({name: "Login"})
                }

              }
              else{
                localStorage.removeItem('sesionID');
                self.$router.push({name: "Login"})
              }
            });
       
    }
    
   
  }
}
  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#wrapper {
  margin: 0;
  padding: 0px 10px;
  background-color: #fff;
  width: 100%;
  background-image: url("~/img/chat-pleca.png"); 
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: bottom center;
  background-size: 100%; 
}

.tituloblanco{

  color:#fff;
}

.avisoNaranja{
  color: orangered;
  font-weight: bold;
  font-size:22px;
}
h2{
  font-family: 'Noto Sans JP', sans-serif;
}
.dot {
  background:#184B9F;
}
.dot, .dot:after {
  display: inline-block;
  width: 2em;
  height: 2em;
  border-radius: 50%;
  animation: a 1.5s calc(((var(--i) + var(--o, 0))/var(--n) - 1)*1.5s) infinite;
}
.dot:after {
  --o: 1;
  background: white;
  content: "";
}
#wrapper{
    background-image: url("/img/fondo.jpeg");
    background-size: cover;
  }

@keyframes a {
  0%, 50% {
    transform: scale(0);
  }
}
</style>